import HeroImg from '../assets/hero.png';
import { AiOutlineLinkedin, AiOutlineGithub, AiOutlineYoutube } from "react-icons/ai";
import { motion } from "framer-motion";

export default function Hero() {
  return (
    <>
      <section id="hero" className="flex flex-col-reverse md:flex-row items-center justify-between px-6 md:px-16 lg:px-32 py-24 bg-primary  shadow-2xl">

        {/* Left - Text */}
        <motion.div
          initial={{ x: -60, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 1.1, ease: "easeOut" }}
          className="w-full md:w-1/2 text-center md:text-left space-y-6"
        >
          <h1 className="text-white text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-snug drop-shadow-lg">
            Hi, I'm <br/><span className="text-pink-400">G. Priyadharshni</span>
          </h1>
          <p className="text-purple-100 text-lg sm:text-xl font-medium italic leading-relaxed">
            A passionate <span className="text-pink-300 font-semibold">MERN Stack Developer</span> building clean, modern, and responsive web applications.
          </p>

          {/* Social Icons */}
          <div className="flex justify-center md:justify-start gap-6 pt-4">
            <motion.a whileHover={{ scale: 1.2 }} className="text-blue-200 hover:text-pink-300 transition" href="https://www.linkedin.com/in/priyadharshnig"
    target="_blank">
              <AiOutlineLinkedin size={32} />
            </motion.a>
            <motion.a whileHover={{ scale: 1.2 }} className="text-blue-200 hover:text-pink-300 transition" target="_blank"href="https://github.com/PriyadharshniG">
              <AiOutlineGithub size={32} />
            </motion.a>
            <motion.a whileHover={{ scale: 1.2 }} className="text-blue-200 hover:text-pink-300 transition"target="_blank"href="https://www.youtube.com/@InnoVisionTamil">
              <AiOutlineYoutube size={32} />
            </motion.a>
          </div>

          {/* Button */}
          <motion.button
  whileHover={{ scale: 1.05 }}
  className="mt-6 px-6 py-3 bg-pink-500 text-white rounded-full hover:bg-pink-600 transition duration-300 shadow-xl hover:scale-105"
  onClick={() => {
    const contactSection = document.getElementById("contact");
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth" });
    }
  }}>
  Hire Me
</motion.button>
</motion.div>

        {/* Right - Image */}
        <motion.div
          initial={{ x: 60, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 1.1, ease: "easeOut" }}
          className="w-full md:w-1/2 flex justify-center md:justify-end mb-10 md:mb-0 pr-10 md:pr-20"
        >
          <div className=" p-3 rounded-3xl shadow-2xl transition-transform duration-500 hover:scale-105">
            <img
              src={HeroImg}
              alt="Hero"
              className="w-[300px] md:w-[360px]  rounded-3xl "
            />
          </div>
        </motion.div>
      </section>

      {/* SVG Wave */}
      <div className="overflow-hidden">
        <svg viewBox="0 0 500 150" preserveAspectRatio="none" className="w-full h-16">
          <path d="M0.00,49.98 C150.00,150.00 349.83,-50.00 500.00,49.98 L500.00,150.00 L0.00,150.00 Z" style={{ fill: '#1e1b4b' }} />
        </svg>
      </div>
    </>
  );
}
